import { customerKeys } from '../components/customers/customerKeys';
import { format } from 'date-fns';
import { Customer } from 'types/customer';

/**
 * Az ügyfél adatokat a dokumentumgeneráláshoz használható kulcs-érték párokká alakítja
 * 
 * @param customer Az ügyfél objektum
 * @returns A kulcs-érték párok objektuma, ami a dokumentumgeneráláshoz használható
 */
export const customerToKeyValuePairs = (customer: Customer): Record<string, string> => {
  // Lemásoljuk a sablont, hogy ne módosítsuk az eredetit
  const mappedData = { ...customerKeys } as Record<string, string>;

  if (!customer) return mappedData;

  // Alapadatok
  if (customer.type === 'organization') {
    mappedData['Cég megnevezése'] = customer.companyName || '';
  } else {
    mappedData['Cég megnevezése'] = `${customer.firstName || ''} ${customer.lastName || ''}`.trim();
  }

  // Adószám és cégjegyzékszám
  mappedData['Cég adószáma'] = customer.taxNumber || '';
  mappedData['Cégjegyzékszám'] = customer.registrationNumber || '';

  // Bankszámlaszám
  mappedData['Bankszámlaszáma'] = customer.bankAccount || '';

  // Kapcsolattartó adatok
  if (customer.contactPerson) {
    mappedData['Kapcsolattartó neve'] = customer.contactPerson.name || '';
    mappedData['Kapcsolattartó e-mail'] = customer.contactPerson.email || '';
    mappedData['Kapcsolattartó telefon'] = customer.contactPerson.phone || '';

    if ('fax' in customer.contactPerson && customer.contactPerson.fax) {
      mappedData['Kapcsolattartó fax'] = customer.contactPerson.fax;
    }
  }

  // Cím adatok
  if (customer.address) {
    const addressParts = [];
    if (customer.address.postalCode) addressParts.push(customer.address.postalCode);
    if (customer.address.city) addressParts.push(customer.address.city);
    if (customer.address.street) addressParts.push(customer.address.street);
    
    mappedData['Cég címe'] = addressParts.join(', ');
  }

  // Aktuális dátum
  mappedData['Dátum'] = format(new Date(), 'yyyy.MM.dd.');

  return mappedData;
}; 